import React, { useCallback } from 'react';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the cover editor; each part uses its own slice of it */
import styles from '../../CoverEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ToggleProps {
  label: string;
  isOn: boolean;
  disabled?: boolean;
  onChange: (isOn: boolean) => void;
}

/** A small on and off switch (design cover-editor b1: Shadow, Outline; d3: an effect). */
const ToggleComponent: React.FC<ToggleProps> = ({ label, isOn, disabled, onChange }) => {
  const toggle = useCallback(() => onChange(!isOn), [isOn, onChange]);
  return (
    <button
      type="button"
      role="switch"
      aria-checked={isOn}
      aria-label={label}
      className={clsx(styles.toggle, isOn && styles.toggleOn)}
      disabled={disabled}
      onClick={toggle}
    />
  );
};

export const Toggle = TypedMemo(ToggleComponent);
